// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1rOeG","buttons":"SendReceipts_buttons__93Nhs","email":"SendReceipts_email__B3xNA","bookApptTitle":"SendReceipts_bookApptTitle__2wrkr"};